import pb from '../lib/pocketbase';

export async function getRoles(page, perPage) {
  return await pb.collection('role').getList(page, perPage, {
    sort: '-created',
    $autoCancel: false
  });
}

export async function createRole(role) {
  return await pb.collection('role').create(role);
}

export async function updateRole(id, role) {
  return await pb.collection('role').update(id, role);
}

export async function deleteRole(id) {
  return await pb.collection('role').delete(id);
}